import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { GraphQLClient } from 'graphql-request';
import getConfig from 'next/config';
import { WB_SESSION_ID } from '../global-constants';
import { getNodeFetch } from './nodeFetch';
var cachedBrowserGqlClient = null;
var getGQLClientBrowser = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  if (!cachedBrowserGqlClient) {
    var _ref = getConfig() || {},
      _ref$publicRuntimeCon = _ref.publicRuntimeConfig,
      publicRuntimeConfig = _ref$publicRuntimeCon === void 0 ? {} : _ref$publicRuntimeCon;
    cachedBrowserGqlClient = new GraphQLClient(publicRuntimeConfig.NEXT_PUBLIC_GRAPHQL_ENDPOINT || '', {});
    var sessionIdCookie = getCookie('WB-SESSION-ID');
    if (sessionIdCookie) {
      cachedBrowserGqlClient.setHeader('WB-SESSION-ID', sessionIdCookie.value);
    }
  }
  return cachedBrowserGqlClient;
};
var getGQLClientServer = sessionId => {
  var _process, _process2;
  var _ref2 = getConfig() || {},
    _ref2$publicRuntimeCo = _ref2.publicRuntimeConfig,
    publicRuntimeConfig = _ref2$publicRuntimeCo === void 0 ? {} : _ref2$publicRuntimeCo;
  var endpoint = ((_process = process) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.NEXT_ENABLE_SERVER_APOLLO_GRAPHQL_ENDPOINT) === 'true' ? (_process2 = process) === null || _process2 === void 0 || (_process2 = _process2.env) === null || _process2 === void 0 ? void 0 : _process2.NEXT_PUBLIC_SERVER_APOLLO_GRAPHQL_ENDPOINT : publicRuntimeConfig.NEXT_PUBLIC_GRAPHQL_ENDPOINT || '';
  var headers = {};
  if (sessionId) {
    headers[WB_SESSION_ID] = sessionId;
  }
  return new GraphQLClient(endpoint, {
    fetch: getNodeFetch(),
    headers
  });
};
export function getGQLClient(sessionId) {
  return typeof window !== 'undefined' ? getGQLClientBrowser() : getGQLClientServer(sessionId);
}
export function getCookie(name) {
  var allCookies = document.cookie.split(';').map(cookie => {
    if (!cookie) {
      return null;
    }
    var _cookie$split = cookie.split('='),
      _cookie$split2 = _slicedToArray(_cookie$split, 2),
      name = _cookie$split2[0],
      value = _cookie$split2[1];
    return {
      name: name.trim(),
      value: value.trim()
    };
  }).filter(c => c !== null);
  var sessionIdCookie = allCookies.find(c => (c === null || c === void 0 ? void 0 : c.name) === name);
  return sessionIdCookie;
}